import React from 'react';
import States from './States';

const DocumentStates = () => {
  const urlFragment = 'cus/statesClients';

  return <States urlFragment={urlFragment} />;
};

export default DocumentStates;
